module.exports = __webpack_public_path__ + "static/media/halasz_fishing_img02.3546849c.png";